import React, { useEffect, useState } from 'react';
import { useClimate } from '../../contexts/ClimateContext';
import SnowfallEffect from './SnowfallEffect';
import RainEffect from './RainEffect';
import SunnyEffect from './SunnyEffect';
import WindyEffect from './WindyEffect';
import '../../styles/climate-effects.css';

const ClimateEffects = () => {
    const { climate } = useClimate();
    const [celestial, setCelestial] = useState({ isDay: true, phase: 'day' });

    useEffect(() => {
        const updateCelestial = () => {
            const hour = new Date().getHours();
            let isDay = true;
            let phase = 'day';

            if (hour >= 6 && hour < 8) {
                isDay = true;
                phase = 'sunrise';
            } else if (hour >= 8 && hour < 16) {
                isDay = true;
                phase = 'day';
            } else if (hour >= 16 && hour < 18) {
                isDay = true;
                phase = 'sunset';
            } else if (hour >= 18 && hour < 20) {
                isDay = false;
                phase = 'moonrise';
            } else if (hour >= 20 || hour < 4) {
                isDay = false;
                phase = 'night';
            } else {
                isDay = false;
                phase = 'moonset';
            }

            setCelestial({ isDay, phase });
        };

        updateCelestial();
        // Check every minute to keep in sync
        const interval = setInterval(updateCelestial, 60000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="climate-effects-overlay">
            {/* Global Diurnal Celestial Body (Sun / Moon) */}
            <div className="celestial-container">
                <div className={`celestial-body ${celestial.phase} ${climate === 'rainy' ? 'obscured' : ''}`}>
                    {celestial.isDay ? (
                        <div className="celestial-sun">
                            <div className="sun-core-premium" />
                            <div className="sun-rays-container">
                                {[...Array(16)].map((_, i) => (
                                    <div
                                        key={i}
                                        className="sun-ray-premium"
                                        style={{ transform: `rotate(${i * 22.5}deg)` }}
                                    />
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div className="celestial-moon">
                            <div className="moon-crescent" />
                            <div className="moon-glow" />
                        </div>
                    )}
                </div>
            </div>

            {climate === 'snowy' && <SnowfallEffect />}
            {climate === 'rainy' && <RainEffect />}
            {climate === 'sunny' && <SunnyEffect />}
            {climate === 'windy' && <WindyEffect />}
        </div>
    );
};

export default ClimateEffects;
